import { Link } from "react-router-dom";

const AgencyHowItWork = () => {
  return (
    <>
      <section className="hd-htw-section ah-bg pb-120 pt-60 position-relative overflow-hidden z-1">
        <div className="container">
          <div className="row align-items-center g-5 justify-content-center">
            <div className="col-lg-6">
              <div className="hd-description text-center text-lg-end hd-border-right position-relative">
                <p>
                  Enthusiastically customize cutting-edge technology whereas
                  open-source relationships. Seamlessly enable orthogonal
                  leadership and 24/7 initiatives customers need it, and give
                  your team the collaboration.
                </p>
              </div>
            </div>
            <div className="col-lg-6 col-md-8">
              <div className="hd-title text-center text-lg-start">
                <h2 className="clr-text">
                  Start with Quiety in{" "}
                  <mark className="bg-transparent p-0 position-relative ms-1">
                    1, 2, 3{" "}
                    <img
                      src="assets/img/shape/arrow-rounded.png"
                      alt=""
                      className="arrow-rounded position-absolute"
                    />
                  </mark>{" "}
                  Simple Steps!
                </h2>
              </div>
            </div>
          </div>
          <div className="mt-5">
            <div className="row justify-content-center g-4">
              <div className="col-xl-4 col-lg-6">
                <div className="htw-single-box bg-white position-relative py-5 px-4 rounded z-1">
                  <span className="number-serial ah-text-outline position-absolute">
                    1
                  </span>
                  <span className="icon-wrapper ah-style bg-style-1 fix d-inline-flex justify-content-center align-items-center">
                    <svg
                      width="101"
                      height="96"
                      viewBox="0 0 101 96"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g filter="url(#filter0_d_2710_6248)">
                        <path
                          d="M46.9797 21.7311H29.9128C27.1996 21.7311 25 23.9306 25 26.6439V62.0638C25 64.7772 27.1996 66.9768 29.9128 66.9768H46.9797C49.6929 66.9768 51.8925 64.7772 51.8925 62.0638V26.6439C51.8925 23.9306 49.6929 21.7311 46.9797 21.7311Z"
                          fill="white"
                          fillOpacity="0.01"
                        />
                      </g>
                      <path
                        d="M46.9797 21.6434H29.9128C27.1996 21.6434 25 23.843 25 26.5563V61.9763C25 64.6895 27.1996 66.8891 29.9128 66.8891H46.9797C49.6929 66.8891 51.8925 64.6895 51.8925 61.9763V26.5563C51.8925 23.843 49.6929 21.6434 46.9797 21.6434Z"
                        fill="white"
                      />
                      <g filter="url(#filter1_d_2710_6248)">
                        <path
                          d="M47.2351 58.5355H29.6768C28.3495 58.5355 27.2734 59.6116 27.2734 60.9389C27.2734 62.2663 28.3495 63.3422 29.6768 63.3422H47.2351C48.5625 63.3422 49.6386 62.2663 49.6386 60.9389C49.6386 59.6116 48.5625 58.5355 47.2351 58.5355Z"
                          fill="#FF3951"
                          fillOpacity="0.01"
                        />
                      </g>
                      <path
                        d="M47.2351 58.4907H29.6768C28.3495 58.4907 27.2734 59.5668 27.2734 60.8941C27.2734 62.2215 28.3495 63.2974 29.6768 63.2974H47.2351C48.5625 63.2974 49.6386 62.2215 49.6386 60.8941C49.6386 59.5668 48.5625 58.4907 47.2351 58.4907Z"
                        fill="#FF3951"
                      />
                      <g filter="url(#filter2_d_2710_6248)">
                        <path
                          d="M28.572 49.4438C29.2503 49.4438 29.8002 48.8938 29.8002 48.2155C29.8002 47.5373 29.2503 46.9873 28.572 46.9873C27.8936 46.9873 27.3438 47.5373 27.3438 48.2155C27.3438 48.8938 27.8936 49.4438 28.572 49.4438Z"
                          fill="#FF3951"
                          fillOpacity="0.01"
                        />
                      </g>
                      <path
                        d="M28.572 49.3471C29.2503 49.3471 29.8002 48.7971 29.8002 48.1189C29.8002 47.4404 29.2503 46.8906 28.572 46.8906C27.8936 46.8906 27.3438 47.4404 27.3438 48.1189C27.3438 48.7971 27.8936 49.3471 28.572 49.3471Z"
                        fill="#FF3951"
                      />
                      <g filter="url(#filter3_d_2710_6248)">
                        <path
                          d="M28.572 53.034C29.2503 53.034 29.8002 52.484 29.8002 51.8058C29.8002 51.1275 29.2503 50.5775 28.572 50.5775C27.8936 50.5775 27.3438 51.1275 27.3438 51.8058C27.3438 52.484 27.8936 53.034 28.572 53.034Z"
                          fill="#FF8139"
                          fillOpacity="0.01"
                        />
                      </g>
                      <path
                        d="M28.572 53.1C29.2503 53.1 29.8002 52.5501 29.8002 51.8718C29.8002 51.1934 29.2503 50.6436 28.572 50.6436C27.8936 50.6436 27.3438 51.1934 27.3438 51.8718C27.3438 52.5501 27.8936 53.1 28.572 53.1Z"
                        fill="#FF8139"
                      />
                      <g filter="url(#filter4_d_2710_6248)">
                        <path
                          d="M28.572 56.6242C29.2503 56.6242 29.8002 56.0742 29.8002 55.396C29.8002 54.7177 29.2503 54.1677 28.572 54.1677C27.8936 54.1677 27.3438 54.7177 27.3438 55.396C27.3438 56.0742 27.8936 56.6242 28.572 56.6242Z"
                          fill="#FFC226"
                          fillOpacity="0.01"
                        />
                      </g>
                      <path
                        d="M28.572 56.6823C29.2503 56.6823 29.8002 56.1323 29.8002 55.4541C29.8002 54.7756 29.2503 54.2258 28.572 54.2258C27.8936 54.2258 27.3438 54.7756 27.3438 55.4541C27.3438 56.1323 27.8936 56.6823 28.572 56.6823Z"
                        fill="#FFC226"
                      />
                      <path
                        d="M46.6696 47.7432H31.1384C30.8775 47.7432 30.666 47.9547 30.666 48.2155C30.666 48.4764 30.8775 48.6879 31.1384 48.6879H46.6696C46.9304 48.6879 47.142 48.4764 47.142 48.2155C47.142 47.9547 46.9304 47.7432 46.6696 47.7432Z"
                        fill="#D9DBE9"
                      />
                      <path
                        d="M43.0743 51.3335H31.1384C30.8775 51.3335 30.666 51.545 30.666 51.8059C30.666 52.0667 30.8775 52.2782 31.1384 52.2782H43.0743C43.3353 52.2782 43.5466 52.0667 43.5466 51.8059C43.5466 51.545 43.3353 51.3335 43.0743 51.3335Z"
                        fill="#D9DBE9"
                      />
                      <path
                        d="M49.0392 54.9233H31.1384C30.8775 54.9233 30.666 55.1349 30.666 55.3957C30.666 55.6567 30.8775 55.8681 31.1384 55.8681H49.0392C49.3001 55.8681 49.5116 55.6567 49.5116 55.3957C49.5116 55.1349 49.3001 54.9233 49.0392 54.9233Z"
                        fill="#D9DBE9"
                      />
                      <path
                        d="M46.9833 23.8912H29.909C28.448 23.8912 27.2637 25.0756 27.2637 26.5366V42.4307C27.2637 43.8918 28.448 45.0762 29.909 45.0762H46.9833C48.4444 45.0762 49.6288 43.8918 49.6288 42.4307V26.5366C49.6288 25.0756 48.4444 23.8912 46.9833 23.8912Z"
                        fill="#F1F3F9"
                      />
                      <path
                        d="M46.684 34.4836C46.684 39.0334 42.9957 42.7215 38.446 42.7215C33.8963 42.7215 30.208 39.0334 30.208 34.4836C30.208 29.9339 33.8963 26.2456 38.446 26.2456C42.9957 26.2456 46.684 29.9339 46.684 34.4836ZM33.8992 34.4836C33.8992 36.9947 35.9349 39.0303 38.446 39.0303C40.957 39.0303 42.9927 36.9947 42.9927 34.4836C42.9927 31.9725 40.957 29.9369 38.446 29.9369C35.9349 29.9369 33.8992 31.9725 33.8992 34.4836Z"
                        fill="white"
                      />
                      <g filter="url(#filter5_d_2710_6248)">
                        <path
                          d="M39.3154 28.1375C40.2078 28.2597 41.0645 28.5688 41.8292 29.0445C42.5942 29.5203 43.2501 30.152 43.7542 30.8985C44.2584 31.6448 44.5994 32.4892 44.7552 33.3765C44.9107 34.2635 44.8777 35.1736 44.6578 36.0472"
                          stroke="#FFC226"
                          strokeOpacity="0.01"
                          strokeWidth="7.2791"
                          strokeLinecap="round"
                        />
                      </g>
                      <path
                        d="M39.3154 28.1257C40.2078 28.248 41.0645 28.557 41.8292 29.0328C42.5942 29.5086 43.2501 30.1403 43.7542 30.8867C44.2584 31.633 44.5994 32.4775 44.7552 33.3647C44.9107 34.2518 44.8777 35.1618 44.6578 36.0354"
                        stroke="#FFC226"
                        strokeWidth="7.2791"
                        strokeLinecap="round"
                      />
                      <g filter="url(#filter6_d_2710_6248)">
                        <path
                          d="M33.2583 30.7268C34.2232 29.3944 35.6636 28.4843 37.2813 28.1851C38.899 27.8859 40.5697 28.2206 41.9474 29.1198"
                          stroke="#FF8139"
                          strokeOpacity="0.01"
                          strokeWidth="7.2791"
                          strokeLinecap="round"
                        />
                      </g>
                      <path
                        d="M33.2583 30.7743C34.2232 29.4419 35.6636 28.5318 37.2813 28.2326C38.899 27.9334 40.5697 28.268 41.9474 29.1672"
                        stroke="#FF8139"
                        strokeWidth="7.2791"
                        strokeLinecap="round"
                      />
                      <g filter="url(#filter7_d_2710_6248)">
                        <path
                          d="M39.7067 40.7638C38.4906 41.0078 37.2299 40.8935 36.0776 40.435C34.9252 39.9762 33.9309 39.1929 33.2151 38.1799C32.4995 37.167 32.0931 35.9681 32.0457 34.7288C31.9983 33.4894 32.3115 32.2631 32.9476 31.1982"
                          stroke="#FF3951"
                          strokeOpacity="0.01"
                          strokeWidth="7.2791"
                          strokeLinecap="round"
                        />
                      </g>
                      <path
                        d="M39.6774 40.7621C38.4613 41.0061 37.2006 40.8918 36.0483 40.4332C34.8959 39.9745 33.9016 39.1912 33.1858 38.1782C32.4702 37.1653 32.0638 35.9664 32.0164 34.727C31.969 33.4877 32.2822 32.2613 32.9183 31.1965"
                        stroke="#FF3951"
                        strokeWidth="7.2791"
                        strokeLinecap="round"
                      />
                      <g filter="url(#filter8_d_2710_6248)">
                        <path
                          d="M63.7199 34.048H48.1648C45.0339 34.048 42.4961 36.5858 42.4961 39.7166V55.2718C42.4961 58.4024 45.0339 60.9405 48.1648 60.9405H63.7199C66.8506 60.9405 69.3886 58.4024 69.3886 55.2718V39.7166C69.3886 36.5858 66.8506 34.048 63.7199 34.048Z"
                          fill="white"
                          fillOpacity="0.01"
                        />
                      </g>
                      <path
                        d="M63.7199 34.0964H48.1648C45.0339 34.0964 42.4961 36.6345 42.4961 39.7651V55.3203C42.4961 58.4509 45.0339 60.9889 48.1648 60.9889H63.7199C66.8506 60.9889 69.3886 58.4509 69.3886 55.3203V39.7651C69.3886 36.6345 66.8506 34.0964 63.7199 34.0964Z"
                        fill="white"
                      />
                      <g filter="url(#filter9_d_2710_6248)">
                        <path
                          d="M47.7603 45.9526C47.1115 45.9526 46.5854 46.4787 46.5854 47.1275V55.7751C46.5854 56.4239 47.1115 56.95 47.7603 56.95C48.4092 56.95 48.9353 56.4239 48.9353 55.7751V47.1275C48.9353 46.4787 48.4092 45.9526 47.7603 45.9526Z"
                          fill="#FF3951"
                          fillOpacity="0.01"
                        />
                        <path
                          d="M51.8023 42.1741C51.1535 42.1741 50.6274 42.7002 50.6274 43.3489V55.7751C50.6274 56.424 51.1535 56.95 51.8023 56.95C52.4512 56.95 52.9773 56.424 52.9773 55.7751V43.3489C52.9773 42.7002 52.4512 42.1741 51.8023 42.1741Z"
                          fill="#FF3951"
                          fillOpacity="0.01"
                        />
                        <path
                          d="M55.8438 45.9526C55.195 45.9526 54.6689 46.4787 54.6689 47.1275V55.7751C54.6689 56.4241 55.195 56.95 55.8438 56.95C56.4927 56.95 57.0188 56.4241 57.0188 55.7751V47.1275C57.0188 46.4787 56.4927 45.9526 55.8438 45.9526Z"
                          fill="#FF3951"
                          fillOpacity="0.01"
                        />
                        <path
                          d="M59.8853 41.2288C59.2365 41.2288 58.7104 41.7549 58.7104 42.4036V55.7751C58.7104 56.424 59.2365 56.9501 59.8853 56.9501C60.5342 56.9501 61.0603 56.424 61.0603 55.7751V42.4036C61.0603 41.7549 60.5342 41.2288 59.8853 41.2288Z"
                          fill="#FF3951"
                          fillOpacity="0.01"
                        />
                        <path
                          d="M64.1246 38.0382C63.4758 38.0382 62.9497 38.5643 62.9497 39.2131V55.7749C62.9497 56.4238 63.4758 56.9499 64.1246 56.9499C64.7735 56.9499 65.2996 56.4238 65.2996 55.7749V39.2131C65.2996 38.5643 64.7735 38.0382 64.1246 38.0382Z"
                          fill="#FF3951"
                          fillOpacity="0.01"
                        />
                      </g>
                      <path
                        d="M47.7603 45.9343C47.1115 45.9343 46.5854 46.4604 46.5854 47.1093V55.7568C46.5854 56.4058 47.1115 56.9317 47.7603 56.9317C48.4092 56.9317 48.9353 56.4058 48.9353 55.7568V47.1093C48.9353 46.4604 48.4092 45.9343 47.7603 45.9343Z"
                        fill="#FF3951"
                      />
                      <path
                        d="M51.8018 42.1558C51.153 42.1558 50.627 42.6819 50.627 43.3308V55.7568C50.627 56.4057 51.153 56.9317 51.8018 56.9317C52.4507 56.9317 52.9768 56.4057 52.9768 55.7568V43.3308C52.9768 42.6819 52.4507 42.1558 51.8018 42.1558Z"
                        fill="#FF3951"
                      />
                      <path
                        d="M55.8438 45.9343C55.195 45.9343 54.6689 46.4604 54.6689 47.1093V55.7568C54.6689 56.4058 55.195 56.9317 55.8438 56.9317C56.4927 56.9317 57.0188 56.4058 57.0188 55.7568V47.1093C57.0188 46.4604 56.4927 45.9343 55.8438 45.9343Z"
                        fill="#FF3951"
                      />
                      <path
                        d="M59.8853 41.2104C59.2365 41.2104 58.7104 41.7365 58.7104 42.3853V55.7567C58.7104 56.4057 59.2365 56.9318 59.8853 56.9318C60.5342 56.9318 61.0603 56.4057 61.0603 55.7567V42.3853C61.0603 41.7365 60.5342 41.2104 59.8853 41.2104Z"
                        fill="#FF3951"
                      />
                      <path
                        d="M64.1246 38.02C63.4758 38.02 62.9497 38.5461 62.9497 39.1949V55.7568C62.9497 56.4056 63.4758 56.9317 64.1246 56.9317C64.7735 56.9317 65.2996 56.4056 65.2996 55.7568V39.1949C65.2996 38.5461 64.7735 38.02 64.1246 38.02Z"
                        fill="#FF3951"
                      />
                      <defs>
                        <filter
                          id="filter0_d_2710_6248"
                          x="0.982777"
                          y="0.716007"
                          width="74.927"
                          height="93.2802"
                          filterUnits="userSpaceOnUse"
                          colorInterpolationFilters="sRGB"
                        >
                          <feFlood
                            floodOpacity="0"
                            result="BackgroundImageFix"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="3.00215" />
                          <feGaussianBlur stdDeviation="12.0086" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_2710_6248"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_2710_6248"
                            result="shape"
                          />
                        </filter>
                        <filter
                          id="filter1_d_2710_6248"
                          x="22.0197"
                          y="55.5334"
                          width="32.8728"
                          height="15.3142"
                          filterUnits="userSpaceOnUse"
                          colorInterpolationFilters="sRGB"
                        >
                          <feFlood
                            floodOpacity="0"
                            result="BackgroundImageFix"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="2.25161" />
                          <feGaussianBlur stdDeviation="2.62688" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 1 0 0 0 0 0.223529 0 0 0 0 0.317647 0 0 0 0.37 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_2710_6248"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_2710_6248"
                            result="shape"
                          />
                        </filter>
                        <filter
                          id="filter2_d_2710_6248"
                          x="25.4674"
                          y="45.8615"
                          width="6.20923"
                          height="6.20911"
                          filterUnits="userSpaceOnUse"
                          colorInterpolationFilters="sRGB"
                        >
                          <feFlood
                            floodOpacity="0"
                            result="BackgroundImageFix"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="0.750538" />
                          <feGaussianBlur stdDeviation="0.938171" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 1 0 0 0 0 0.223529 0 0 0 0 0.317647 0 0 0 0.35 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_2710_6248"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_2710_6248"
                            result="shape"
                          />
                        </filter>
                        <filter
                          id="filter3_d_2710_6248"
                          x="25.0921"
                          y="49.0764"
                          width="6.95976"
                          height="6.95964"
                          filterUnits="userSpaceOnUse"
                          colorInterpolationFilters="sRGB"
                        >
                          <feFlood
                            floodOpacity="0"
                            result="BackgroundImageFix"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="0.750538" />
                          <feGaussianBlur stdDeviation="1.12581" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 1 0 0 0 0 0.504861 0 0 0 0 0.225 0 0 0 0.32 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_2710_6248"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_2710_6248"
                            result="shape"
                          />
                        </filter>
                        <filter
                          id="filter4_d_2710_6248"
                          x="23.5911"
                          y="51.5408"
                          width="9.96191"
                          height="9.96191"
                          filterUnits="userSpaceOnUse"
                          colorInterpolationFilters="sRGB"
                        >
                          <feFlood
                            floodOpacity="0"
                            result="BackgroundImageFix"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="1.12581" />
                          <feGaussianBlur stdDeviation="1.87634" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 1 0 0 0 0 0.760784 0 0 0 0 0.14902 0 0 0 0.33 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_2710_6248"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_2710_6248"
                            result="shape"
                          />
                        </filter>
                        <filter
                          id="filter5_d_2710_6248"
                          x="33.4356"
                          y="23.3776"
                          width="17.2954"
                          height="19.6696"
                          filterUnits="userSpaceOnUse"
                          colorInterpolationFilters="sRGB"
                        >
                          <feFlood
                            floodOpacity="0"
                            result="BackgroundImageFix"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="1.11986" />
                          <feGaussianBlur stdDeviation="1.11986" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 1 0 0 0 0 0.760784 0 0 0 0 0.14902 0 0 0 0.21 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_2710_6248"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_2710_6248"
                            result="shape"
                          />
                        </filter>
                        <filter
                          id="filter6_d_2710_6248"
                          x="27.3789"
                          y="23.3189"
                          width="20.4482"
                          height="14.4073"
                          filterUnits="userSpaceOnUse"
                          colorInterpolationFilters="sRGB"
                        >
                          <feFlood
                            floodOpacity="0"
                            result="BackgroundImageFix"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="1.11986" />
                          <feGaussianBlur stdDeviation="1.11986" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 1 0 0 0 0 0.505882 0 0 0 0 0.223529 0 0 0 0.16 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_2710_6248"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_2710_6248"
                            result="shape"
                          />
                        </filter>
                        <filter
                          id="filter7_d_2710_6248"
                          x="23.9219"
                          y="24.7585"
                          width="23.9047"
                          height="25.9293"
                          filterUnits="userSpaceOnUse"
                          colorInterpolationFilters="sRGB"
                        >
                          <feFlood
                            floodOpacity="0"
                            result="BackgroundImageFix"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="1.67979" />
                          <feGaussianBlur stdDeviation="2.23972" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 1 0 0 0 0 0.223529 0 0 0 0 0.317647 0 0 0 0.34 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_2710_6248"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_2710_6248"
                            result="shape"
                          />
                        </filter>
                        <filter
                          id="filter8_d_2710_6248"
                          x="10.9735"
                          y="5.90283"
                          width="89.9377"
                          height="89.9376"
                          filterUnits="userSpaceOnUse"
                          colorInterpolationFilters="sRGB"
                        >
                          <feFlood
                            floodOpacity="0"
                            result="BackgroundImageFix"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="3.37742" />
                          <feGaussianBlur stdDeviation="15.7613" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0.416667 0 0 0 0 0.0329861 0 0 0 0 0.0329861 0 0 0 0.33 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_2710_6248"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_2710_6248"
                            result="shape"
                          />
                        </filter>
                        <filter
                          id="filter9_d_2710_6248"
                          x="43.9586"
                          y="35.7866"
                          width="23.9681"
                          height="24.1656"
                          filterUnits="userSpaceOnUse"
                          colorInterpolationFilters="sRGB"
                        >
                          <feFlood
                            floodOpacity="0"
                            result="BackgroundImageFix"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="0.375267" />
                          <feGaussianBlur stdDeviation="1.31344" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 1 0 0 0 0 0.223529 0 0 0 0 0.317647 0 0 0 0.32 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_2710_6248"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_2710_6248"
                            result="shape"
                          />
                        </filter>
                      </defs>
                    </svg>
                  </span>
                  <h4 className="mt-3 mb-3">Start Your HelpDesk</h4>
                  <p className="mb-4">
                    Be available right where your custom collaboration messages
                    in one place Build better bonds automatically.
                  </p>
                  <Link
                    href="/register"
                    className="read-more-link dat-about-btn"
                  >
                    Free sign up{" "}
                    <i className="fa-solid fa-arrow-right-long ms-1"></i>
                  </Link>
                </div>
              </div>
              <div className="col-xl-4 col-lg-6">
                <div className="htw-single-box bg-white position-relative py-5 px-4 rounded z-1 mts-50">
                  <span className="number-serial ah-text-outline position-absolute">
                    2
                  </span>
                  <span className="icon-wrapper ah-style bg-style-2 d-inline-flex justify-content-center align-items-center">
                    <svg
                      width="68"
                      height="61"
                      viewBox="0 0 68 61"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g filter="url(#filter0_d_2710_6294)">
                        <path
                          d="M33.0999 6.40417L10.9609 10.3079C8.35442 10.7675 6.61402 13.253 7.07361 15.8596L10.4228 34.8534C10.8823 37.4601 13.3679 39.2004 15.9744 38.7408L38.1133 34.8371C40.72 34.3776 42.4603 31.892 42.0007 29.2855L38.6516 10.2915C38.192 7.68499 35.7064 5.94458 33.0999 6.40417Z"
                          fill="white"
                          fillOpacity="0.01"
                        />
                      </g>
                      <path
                        d="M33.0999 6.38366L10.9609 10.2874C8.35442 10.747 6.61402 13.2325 7.07361 15.839L10.4228 34.833C10.8823 37.4395 13.3679 39.18 15.9744 38.7202L38.1133 34.8166C40.72 34.357 42.4603 31.8714 42.0007 29.2649L38.6516 10.271C38.192 7.66448 35.7064 5.92407 33.0999 6.38366Z"
                        fill="white"
                      />
                      <path
                        opacity="0.13"
                        d="M19.5726 26.2682C12.9411 25.6247 17.867 34.9672 13.2944 35.7735L37.487 31.5077C38.6629 31.3002 39.448 30.1789 39.2408 29.0031L37.7004 20.2677L35.7856 9.40771C33.9754 11.4685 34.8917 17.9745 30.6967 18.2149C26.5015 18.4553 26.2041 26.9119 19.5726 26.2682Z"
                        fill="#FF8139"
                      />
                      <g filter="url(#filter1_d_2710_6294)">
                        <path
                          d="M13.4893 35.5685C18.0359 34.7668 11.5738 26.3851 20.1045 26.1969C28.6351 26.0086 25.6456 18.62 30.6942 18.2694C35.7428 17.9186 33.3655 11.0561 35.6302 9.39795"
                          stroke="#FF8139"
                          strokeOpacity="0.01"
                          strokeWidth="0.935494"
                          strokeLinecap="round"
                        />
                      </g>
                      <path
                        d="M13.5479 35.5685C18.0945 34.7668 11.6323 26.3851 20.1631 26.1969C28.6937 26.0086 25.7043 18.62 30.7529 18.2694C35.8015 17.9186 33.4242 11.0561 35.6888 9.39795"
                        stroke="#FF8139"
                        strokeWidth="0.935494"
                        strokeLinecap="round"
                      />
                      <g filter="url(#filter2_d_2710_6294)">
                        <path
                          d="M56.4313 24.667L34.2924 20.7633C31.6858 20.3037 29.2004 22.044 28.7406 24.6505L25.3915 43.6445C24.9319 46.251 26.6724 48.7366 29.2788 49.1961L51.4179 53.0998C54.0244 53.5596 56.51 51.8191 56.9696 49.2126L60.3187 30.2186C60.7783 27.6121 59.0378 25.1265 56.4313 24.667Z"
                          fill="white"
                          fillOpacity="0.01"
                        />
                      </g>
                      <path
                        d="M56.4313 24.6539L34.2924 20.7502C31.6858 20.2907 29.2004 22.031 28.7406 24.6374L25.3915 43.6315C24.9319 46.2379 26.6724 48.7235 29.2788 49.1831L51.4179 53.0868C54.0244 53.5465 56.51 51.806 56.9696 49.1996L60.3187 30.2055C60.7783 27.5991 59.0378 25.1135 56.4313 24.6539Z"
                        fill="white"
                      />
                      <g filter="url(#filter3_d_2710_6294)">
                        <path
                          d="M31.8212 42.8781C31.9258 42.2855 31.5301 41.7205 30.9377 41.6161C30.3452 41.5117 29.7801 41.9073 29.6755 42.4998L29.3321 44.4477C29.2277 45.0401 29.6233 45.6051 30.2159 45.7097C30.8084 45.8141 31.3734 45.4185 31.4778 44.826L31.8212 42.8781Z"
                          fill="#FFC226"
                          fillOpacity="0.01"
                        />
                        <path
                          d="M36.104 39.5564C36.2086 38.9639 35.8128 38.3988 35.2205 38.2944C34.6279 38.19 34.0629 38.5856 33.9583 39.1781L32.9176 45.08C32.8132 45.6725 33.2088 46.2376 33.8013 46.342C34.3938 46.4464 34.9589 46.0508 35.0635 45.4583L36.104 39.5564Z"
                          fill="#FFC226"
                          fillOpacity="0.01"
                        />
                        <path
                          d="M39.8655 39.1924C39.9701 38.5999 39.5743 38.0348 38.982 37.9304C38.3895 37.826 37.8244 38.2216 37.7198 38.8141L36.5036 45.7122C36.399 46.3047 36.7948 46.8697 37.3873 46.9743C37.9797 47.0788 38.5447 46.6832 38.6493 46.0906L39.8655 39.1924Z"
                          fill="#FFC226"
                          fillOpacity="0.01"
                        />
                        <path
                          d="M44.3266 34.8614C44.4312 34.2689 44.0354 33.7038 43.4431 33.5994C42.8505 33.4948 42.2855 33.8906 42.1809 34.4831L40.0895 46.3447C39.9849 46.9372 40.3805 47.5022 40.9731 47.6066C41.5656 47.7111 42.1306 47.3155 42.2352 46.7229L44.3266 34.8614Z"
                          fill="#FFC226"
                          fillOpacity="0.01"
                        />
                        <path
                          d="M47.786 36.2111C47.8906 35.6185 47.4948 35.0535 46.9025 34.9491C46.3099 34.8447 45.7449 35.2403 45.6403 35.8328L43.6754 46.9767C43.571 47.5691 43.9666 48.1343 44.5591 48.2387C45.1517 48.3431 45.7167 47.9475 45.8211 47.355L47.786 36.2111Z"
                          fill="#FFC226"
                          fillOpacity="0.01"
                        />
                        <path
                          d="M52.0529 32.9794C52.1575 32.3868 51.7617 31.8218 51.1693 31.7174C50.5768 31.613 50.0118 32.0086 49.9072 32.6011L47.2609 47.6093C47.1563 48.2018 47.5521 48.7668 48.1444 48.8713C48.737 48.9757 49.302 48.5801 49.4066 47.9876L52.0529 32.9794Z"
                          fill="#FFC226"
                          fillOpacity="0.01"
                        />
                        <path
                          d="M56.3424 29.6214C56.447 29.0289 56.0512 28.4638 55.4588 28.3594C54.8663 28.2548 54.3013 28.6506 54.1967 29.2431L50.8468 48.2415C50.7424 48.8341 51.138 49.3991 51.7305 49.5035C52.323 49.6079 52.8881 49.2123 52.9925 48.6198L56.3424 29.6214Z"
                          fill="#FFC226"
                          fillOpacity="0.01"
                        />
                      </g>
                      <path
                        d="M31.8212 42.8604C31.9258 42.2679 31.5301 41.7028 30.9377 41.5984C30.3452 41.4938 29.7801 41.8896 29.6755 42.4821L29.3321 44.4299C29.2277 45.0224 29.6233 45.5874 30.2159 45.692C30.8084 45.7964 31.3734 45.4008 31.4778 44.8083L31.8212 42.8604Z"
                        fill="#FFC226"
                      />
                      <path
                        d="M36.104 39.5388C36.2086 38.9462 35.8128 38.3812 35.2205 38.2768C34.6279 38.1722 34.0629 38.568 33.9583 39.1605L32.9176 45.0624C32.8132 45.6549 33.2088 46.2199 33.8013 46.3243C34.3938 46.4288 34.9589 46.0331 35.0635 45.4406L36.104 39.5388Z"
                        fill="#FFC226"
                      />
                      <path
                        d="M39.8655 39.1746C39.9701 38.5821 39.5743 38.0171 38.982 37.9126C38.3895 37.808 37.8244 38.2038 37.7198 38.7964L36.5036 45.6944C36.399 46.2869 36.7948 46.852 37.3873 46.9566C37.9797 47.061 38.5447 46.6654 38.6493 46.0729L39.8655 39.1746Z"
                        fill="#FFC226"
                      />
                      <path
                        d="M44.3266 34.8437C44.4312 34.2511 44.0354 33.6861 43.4431 33.5817C42.8505 33.4771 42.2855 33.8729 42.1809 34.4654L40.0895 46.327C39.9849 46.9195 40.3805 47.4845 40.9731 47.5889C41.5656 47.6934 42.1306 47.2978 42.2352 46.7052L44.3266 34.8437Z"
                        fill="#FFC226"
                      />
                      <path
                        d="M47.786 36.1934C47.8906 35.6009 47.4948 35.0359 46.9025 34.9314C46.3099 34.8268 45.7449 35.2226 45.6403 35.8152L43.6754 46.9589C43.571 47.5514 43.9666 48.1165 44.5591 48.221C45.1517 48.3255 45.7167 47.9299 45.8211 47.3373L47.786 36.1934Z"
                        fill="#FFC226"
                      />
                      <path
                        d="M52.0529 32.9616C52.1575 32.3691 51.7617 31.804 51.1693 31.6996C50.5768 31.595 50.0118 31.9908 49.9072 32.5833L47.2609 47.5915C47.1563 48.184 47.5521 48.7491 48.1444 48.8535C48.737 48.9579 49.302 48.5623 49.4066 47.9698L52.0529 32.9616Z"
                        fill="#FFC226"
                      />
                      <path
                        d="M56.3424 29.6037C56.447 29.0112 56.0512 28.4461 55.4588 28.3417C54.8663 28.2371 54.3013 28.6329 54.1967 29.2254L50.8468 48.2238C50.7424 48.8164 51.138 49.3814 51.7305 49.4858C52.323 49.5902 52.8881 49.1946 52.9925 48.6021L56.3424 29.6037Z"
                        fill="#FFC226"
                      />
                      <defs>
                        <filter
                          id="filter0_d_2710_6294"
                          x="0.251038"
                          y="0.425225"
                          width="48.5721"
                          height="45.9818"
                          filterUnits="userSpaceOnUse"
                          colorInterpolationFilters="sRGB"
                        >
                          <feFlood
                            floodOpacity="0"
                            result="BackgroundImageFix"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="0.843621" />
                          <feGaussianBlur stdDeviation="3.37448" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0.929167 0 0 0 0 0.361756 0 0 0 0 0.0425868 0 0 0 0.36 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_2710_6294"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_2710_6294"
                            result="shape"
                          />
                        </filter>
                        <filter
                          id="filter1_d_2710_6294"
                          x="12.0778"
                          y="8.43437"
                          width="24.964"
                          height="28.9936"
                          filterUnits="userSpaceOnUse"
                          colorInterpolationFilters="sRGB"
                        >
                          <feFlood
                            floodOpacity="0"
                            result="BackgroundImageFix"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="0.447868" />
                          <feGaussianBlur stdDeviation="0.471839" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 1 0 0 0 0 0.504861 0 0 0 0 0.225 0 0 0 0.38 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_2710_6294"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_2710_6294"
                            result="shape"
                          />
                        </filter>
                        <filter
                          id="filter2_d_2710_6294"
                          x="18.5689"
                          y="14.7844"
                          width="48.5721"
                          height="45.9817"
                          filterUnits="userSpaceOnUse"
                          colorInterpolationFilters="sRGB"
                        >
                          <feFlood
                            floodOpacity="0"
                            result="BackgroundImageFix"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="0.843621" />
                          <feGaussianBlur stdDeviation="3.37448" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0.929167 0 0 0 0 0.361756 0 0 0 0 0.0425868 0 0 0 0.36 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_2710_6294"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_2710_6294"
                            result="shape"
                          />
                        </filter>
                        <filter
                          id="filter3_d_2710_6294"
                          x="27.7386"
                          y="27.1162"
                          width="30.1971"
                          height="24.3313"
                          filterUnits="userSpaceOnUse"
                          colorInterpolationFilters="sRGB"
                        >
                          <feFlood
                            floodOpacity="0"
                            result="BackgroundImageFix"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="0.350404" />
                          <feGaussianBlur stdDeviation="0.78841" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 1 0 0 0 0 0.760784 0 0 0 0 0.14902 0 0 0 0.29 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_2710_6294"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_2710_6294"
                            result="shape"
                          />
                        </filter>
                      </defs>
                    </svg>
                  </span>
                  <h4 className="mt-3 mb-3">Simple Ticket Management</h4>
                  <p className="mb-4">
                    Be available right where your custom collaboration messages
                    in one place Build better bonds automatically.
                  </p>
                  <Link
                    href="/register"
                    className="read-more-link dat-about-btn"
                  >
                    Free sign up{" "}
                    <i className="fa-solid fa-arrow-right-long ms-1"></i>
                  </Link>
                </div>
              </div>
              <div className="col-xl-4 col-lg-6">
                <div className="htw-single-box bg-white position-relative py-5 px-4 rounded z-1 mts-100">
                  <span className="number-serial ah-text-outline position-absolute">
                    3
                  </span>
                  <span className="icon-wrapper ah-style bg-style-3 d-inline-flex justify-content-center align-items-center">
                    <svg
                      width="74"
                      height="70"
                      viewBox="0 0 74 70"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g filter="url(#filter0_d_2719_10761)">
                        <path
                          d="M37.0871 10.2955L16.314 11.7481C13.4182 11.9506 11.2348 14.4622 11.4373 17.358L13.1057 41.2167C13.3082 44.1124 15.8198 46.2958 18.7156 46.0934L39.4887 44.6408C42.3845 44.4383 44.5679 41.9266 44.3653 39.0309L42.697 15.1721C42.4945 12.2763 39.9828 10.093 37.0871 10.2955Z"
                          fill="white"
                          fillOpacity="0.01"
                        />
                      </g>
                      <path
                        d="M37.0753 10.2105L16.3022 11.6631C13.4065 11.8656 11.2231 14.3773 11.4256 17.273L13.094 41.1319C13.2965 44.0276 15.8081 46.211 18.7039 46.0084L39.4769 44.5558C42.3729 44.3533 44.556 41.8418 44.3537 38.9459L42.6852 15.0872C42.4827 12.1914 39.9712 10.008 37.0753 10.2105Z"
                        fill="white"
                      />
                      <g filter="url(#filter1_d_2719_10761)">
                        <path
                          d="M18.2074 20.5681C19.1202 20.5042 19.8084 19.7126 19.7446 18.7998C19.6808 17.887 18.8891 17.1988 17.9763 17.2626C17.0635 17.3265 16.3753 18.1182 16.4392 19.0309C16.503 19.9437 17.2947 20.6319 18.2074 20.5681Z"
                          fill="white"
                          fillOpacity="0.01"
                        />
                        <path
                          d="M17.9536 16.9403C17.5662 16.9674 17.1955 17.1088 16.8884 17.3465C16.5813 17.5843 16.3517 17.9078 16.2284 18.2761C16.1052 18.6444 16.0939 19.0409 16.1961 19.4156C16.2983 19.7903 16.5092 20.1263 16.8023 20.3811C17.0954 20.636 17.4575 20.798 17.8427 20.8471C18.228 20.8962 18.6192 20.8298 18.9667 20.6565C19.3143 20.4832 19.6027 20.2108 19.7954 19.8735C19.9881 19.5363 20.0765 19.1496 20.0494 18.7622C20.0125 18.2429 19.7711 17.7594 19.3782 17.4179C18.9853 17.0763 18.4729 16.9046 17.9536 16.9403ZM19.1779 18.1998L18.1666 19.7942C18.1546 19.8126 18.1391 19.8285 18.1209 19.8409C18.1028 19.8532 18.0824 19.8618 18.0608 19.8661C18.0393 19.8705 18.0171 19.8707 17.9956 19.8663C17.974 19.8621 17.9535 19.8535 17.9353 19.8413L17.0928 19.2591C17.0751 19.2469 17.06 19.2313 17.0484 19.2132C17.0367 19.1951 17.0288 19.175 17.0249 19.1538C17.0171 19.1111 17.0266 19.067 17.0513 19.0313C17.076 18.9957 17.1139 18.9712 17.1566 18.9634C17.1777 18.9596 17.1994 18.9599 17.2204 18.9644C17.2414 18.969 17.2614 18.9776 17.279 18.9898L17.9816 19.4756L18.9016 18.025C18.9125 18.0058 18.9273 17.989 18.9449 17.9757C18.9626 17.9623 18.9827 17.9526 19.0042 17.9473C19.0256 17.9419 19.048 17.941 19.0698 17.9445C19.0916 17.948 19.1125 17.9559 19.1312 17.9678C19.1499 17.9796 19.166 17.9951 19.1786 18.0133C19.1911 18.0315 19.1998 18.0521 19.2042 18.0738C19.2086 18.0955 19.2085 18.1178 19.204 18.1395C19.1994 18.1611 19.1906 18.1816 19.1779 18.1998Z"
                          fill="#6A35FF"
                          fillOpacity="0.01"
                        />
                      </g>
                      <path
                        d="M18.2206 20.5683C19.1334 20.5043 19.8216 19.7127 19.7578 18.7999C19.6939 17.8871 18.9023 17.1989 17.9895 17.2628C17.0767 17.3266 16.3885 18.1183 16.4523 19.031C16.5162 19.9438 17.3079 20.632 18.2206 20.5683Z"
                        fill="white"
                      />
                      <path
                        d="M17.9668 16.9403C17.5794 16.9674 17.2087 17.1088 16.9016 17.3465C16.5945 17.5843 16.3648 17.9078 16.2416 18.2761C16.1184 18.6444 16.1071 19.0409 16.2093 19.4156C16.3114 19.7903 16.5224 20.1263 16.8155 20.3811C17.1086 20.636 17.4707 20.798 17.8559 20.8471C18.2412 20.8962 18.6323 20.8298 18.9799 20.6565C19.3275 20.4832 19.6158 20.2108 19.8085 19.8735C20.0013 19.5363 20.0897 19.1496 20.0626 18.7622C20.0257 18.2429 19.7843 17.7594 19.3914 17.4179C18.9985 17.0763 18.4861 16.9046 17.9668 16.9403ZM19.1911 18.1998L18.1798 19.7942C18.1678 19.8126 18.1523 19.8285 18.1341 19.8409C18.116 19.8532 18.0955 19.8618 18.074 19.8661C18.0525 19.8705 18.0303 19.8707 18.0087 19.8663C17.9872 19.8621 17.9667 19.8535 17.9485 19.8413L17.106 19.2591C17.0883 19.2469 17.0732 19.2313 17.0616 19.2132C17.0499 19.1951 17.0419 19.175 17.0381 19.1538C17.0303 19.1111 17.0398 19.067 17.0645 19.0313C17.0892 18.9957 17.127 18.9712 17.1698 18.9634C17.1909 18.9596 17.2126 18.9599 17.2336 18.9644C17.2546 18.969 17.2745 18.9776 17.2922 18.9898L17.9948 19.4756L18.9148 18.025C18.9257 18.0058 18.9405 17.989 18.9581 17.9757C18.9757 17.9623 18.9959 17.9526 19.0173 17.9473C19.0388 17.9419 19.0611 17.941 19.083 17.9445C19.1048 17.948 19.1257 17.9559 19.1444 17.9678C19.1631 17.9796 19.1792 17.9951 19.1918 18.0133C19.2043 18.0315 19.213 18.0521 19.2174 18.0738C19.2217 18.0955 19.2217 18.1178 19.2171 18.1395C19.2126 18.1611 19.2038 18.1816 19.1911 18.1998Z"
                        fill="#6A35FF"
                      />
                      <path
                        opacity="0.9"
                        d="M37.3429 16.6197L21.9072 17.6991C21.4245 17.7328 21.0606 18.1514 21.0945 18.6341C21.1281 19.1167 21.5468 19.4806 22.0293 19.4469L37.465 18.3675C37.9477 18.3337 38.3116 17.9151 38.2778 17.4325C38.2441 16.9499 37.8254 16.586 37.3429 16.6197Z"
                        fill="#D9DBE9"
                      />
                      <g filter="url(#filter2_d_2719_10761)">
                        <path
                          d="M18.5546 25.5345C19.4674 25.4707 20.1556 24.6789 20.0917 23.7661C20.0279 22.8533 19.2362 22.1651 18.3235 22.2291C17.4107 22.2929 16.7225 23.0846 16.7863 23.9972C16.8502 24.91 17.6418 25.5982 18.5546 25.5345Z"
                          fill="white"
                          fillOpacity="0.01"
                        />
                        <path
                          d="M18.3008 21.9067C17.9133 21.9337 17.5427 22.0751 17.2356 22.3129C16.9285 22.5506 16.6988 22.8742 16.5756 23.2425C16.4524 23.6108 16.4411 24.0072 16.5433 24.382C16.6454 24.7566 16.8564 25.0926 17.1495 25.3474C17.4426 25.6023 17.8047 25.7643 18.1899 25.8134C18.5752 25.8625 18.9663 25.7961 19.3139 25.6228C19.6614 25.4495 19.9498 25.1771 20.1425 24.8398C20.3353 24.5027 20.4236 24.1159 20.3966 23.7285C20.3596 23.2092 20.1182 22.7258 19.7254 22.3842C19.3325 22.0427 18.8201 21.871 18.3008 21.9067ZM19.5251 23.1661L18.5138 24.7606C18.5018 24.779 18.4863 24.7948 18.4681 24.8072C18.45 24.8195 18.4295 24.8282 18.408 24.8326C18.3865 24.837 18.3643 24.837 18.3427 24.8326C18.3212 24.8284 18.3007 24.8198 18.2825 24.8076L17.44 24.2254C17.4223 24.2133 17.4072 24.1977 17.3956 24.1795C17.3839 24.1614 17.3759 24.1413 17.3721 24.1202C17.3643 24.0775 17.3738 24.0333 17.3985 23.9978C17.4232 23.962 17.461 23.9375 17.5037 23.9298C17.5249 23.9259 17.5466 23.9263 17.5676 23.9309C17.5886 23.9354 17.6085 23.944 17.6262 23.9563L18.3288 24.4419L19.2488 22.9914C19.2597 22.9721 19.2745 22.9553 19.2921 22.942C19.3097 22.9287 19.3299 22.9191 19.3513 22.9136C19.3728 22.9084 19.3951 22.9073 19.417 22.9108C19.4388 22.9143 19.4597 22.9222 19.4784 22.9341C19.4971 22.9459 19.5132 22.9615 19.5257 22.9797C19.5383 22.9979 19.547 23.0184 19.5514 23.0401C19.5557 23.0619 19.5556 23.0841 19.5511 23.1058C19.5466 23.1276 19.5378 23.1481 19.5251 23.1661Z"
                          fill="#6A35FF"
                          fillOpacity="0.01"
                        />
                      </g>
                      <path
                        d="M18.5546 25.5654C19.4674 25.5014 20.1556 24.7099 20.0917 23.7971C20.0279 22.8843 19.2362 22.1961 18.3235 22.2598C17.4107 22.3238 16.7225 23.1153 16.7863 24.0282C16.8502 24.941 17.6418 25.6291 18.5546 25.5654Z"
                        fill="white"
                      />
                      <path
                        d="M18.3008 21.9376C17.9133 21.9646 17.5427 22.106 17.2356 22.3437C16.9285 22.5815 16.6988 22.9051 16.5756 23.2734C16.4524 23.6416 16.4411 24.038 16.5433 24.4127C16.6454 24.7873 16.8564 25.1235 17.1495 25.3782C17.4426 25.6332 17.8047 25.7952 18.1899 25.8443C18.5752 25.8933 18.9663 25.8269 19.3139 25.6537C19.6614 25.4804 19.9498 25.2078 20.1425 24.8705C20.3353 24.5334 20.4236 24.1468 20.3966 23.7594C20.3596 23.2401 20.1182 22.7565 19.7254 22.4149C19.3325 22.0734 18.8201 21.9019 18.3008 21.9376ZM19.5251 23.197L18.5138 24.7915C18.5018 24.8099 18.4863 24.8257 18.4681 24.8381C18.45 24.8504 18.4295 24.859 18.408 24.8633C18.3865 24.8677 18.3643 24.8677 18.3427 24.8633C18.3212 24.8591 18.3007 24.8507 18.2825 24.8385L17.44 24.2563C17.4223 24.2442 17.4072 24.2286 17.3956 24.2104C17.3839 24.1923 17.3759 24.1722 17.3721 24.1511C17.3643 24.1084 17.3738 24.0642 17.3985 24.0287C17.4232 23.9929 17.461 23.9684 17.5037 23.9607C17.5249 23.9568 17.5466 23.9572 17.5676 23.9617C17.5886 23.9663 17.6085 23.9749 17.6262 23.9871L18.3288 24.4728L19.2488 23.0223C19.2597 23.003 19.2745 22.9862 19.2921 22.9729C19.3097 22.9596 19.3299 22.9499 19.3513 22.9445C19.3728 22.9393 19.3951 22.9382 19.417 22.9417C19.4388 22.9452 19.4597 22.9529 19.4784 22.9648C19.4971 22.9766 19.5132 22.9923 19.5257 23.0106C19.5383 23.0288 19.547 23.0493 19.5514 23.071C19.5557 23.0927 19.5556 23.115 19.5511 23.1367C19.5466 23.1584 19.5378 23.1789 19.5251 23.197Z"
                        fill="#6A35FF"
                      />
                      <path
                        opacity="0.9"
                        d="M31.7714 22L22.2544 22.6654C21.7717 22.6992 21.4078 23.1178 21.4416 23.6005C21.4753 24.0831 21.894 24.447 22.3765 24.4132L31.8937 23.7476C32.3763 23.714 32.7402 23.2954 32.7064 22.8127C32.6726 22.3301 32.2541 21.9662 31.7714 22Z"
                        fill="#D9DBE9"
                      />
                      <path
                        d="M19.2489 35.4671C20.1617 35.4033 20.8498 34.6115 20.7861 33.6987C20.7223 32.7861 19.9306 32.0979 19.0178 32.1617C18.105 32.2255 17.4168 33.0172 17.4807 33.93C17.5445 34.8426 18.3362 35.5308 19.2489 35.4671Z"
                        fill="white"
                      />
                      <path
                        d="M18.9956 31.8393C18.6082 31.8665 18.2375 32.0079 17.9304 32.2456C17.6233 32.4834 17.3936 32.8068 17.2704 33.1752C17.1472 33.5435 17.1359 33.94 17.2381 34.3147C17.3402 34.6893 17.5512 35.0254 17.8443 35.2801C18.1374 35.535 18.4995 35.6971 18.8848 35.7462C19.27 35.7952 19.6611 35.7288 20.0087 35.5555C20.3563 35.3823 20.6447 35.1098 20.8374 34.7726C21.0301 34.4355 21.1184 34.0486 21.0914 33.6612C21.0545 33.1419 20.813 32.6586 20.4202 32.3169C20.0273 31.9754 19.515 31.8038 18.9956 31.8393ZM20.2199 33.0988L19.2086 34.6934C19.1966 34.7118 19.1811 34.7275 19.1629 34.74C19.1448 34.7522 19.1243 34.7608 19.1028 34.7652C19.0813 34.7696 19.0591 34.7698 19.0375 34.7654C19.016 34.7612 18.9955 34.7526 18.9773 34.7403L18.1348 34.1581C18.1171 34.1459 18.102 34.1303 18.0904 34.1122C18.0787 34.0942 18.0707 34.074 18.0669 34.0528C18.0591 34.0102 18.0686 33.9661 18.0933 33.9304C18.118 33.8948 18.1559 33.8703 18.1986 33.8626C18.2197 33.8587 18.2414 33.859 18.2624 33.8636C18.2834 33.868 18.3033 33.8767 18.321 33.8888L19.0236 34.3747L19.9436 32.9242C19.9546 32.9049 19.9693 32.8881 19.9869 32.8748C20.0045 32.8614 20.0247 32.8518 20.0462 32.8464C20.0676 32.8409 20.09 32.8401 20.1118 32.8436C20.1336 32.8471 20.1545 32.855 20.1732 32.8669C20.1919 32.8786 20.208 32.8942 20.2206 32.9124C20.2331 32.9307 20.2418 32.9512 20.2462 32.9729C20.2505 32.9946 20.2505 33.0169 20.246 33.0386C20.2414 33.0601 20.2326 33.0808 20.2199 33.0988Z"
                        fill="#D9DBE9"
                      />
                      <path
                        opacity="0.5"
                        d="M32.4657 31.9327L22.9487 32.5981C22.466 32.632 22.1022 33.0505 22.136 33.5332C22.1696 34.0157 22.5883 34.3796 23.0708 34.346L32.588 33.6804C33.0707 33.6467 33.4346 33.228 33.4008 32.7455C33.367 32.2628 32.9484 31.8989 32.4657 31.9327Z"
                        fill="#D9DBE9"
                      />
                      <g filter="url(#filter3_d_2719_10761)">
                        <path
                          d="M18.9018 30.5008C19.8145 30.437 20.5027 29.6453 20.4389 28.7325C20.3751 27.8196 19.5834 27.1315 18.6706 27.1954C17.7579 27.2592 17.0697 28.0509 17.1335 28.9635C17.1973 29.8763 17.989 30.5645 18.9018 30.5008Z"
                          fill="white"
                          fillOpacity="0.01"
                        />
                        <path
                          d="M18.6479 26.8731C18.2605 26.9 17.8898 27.0414 17.5828 27.2792C17.2757 27.5169 17.046 27.8405 16.9228 28.2088C16.7995 28.5771 16.7883 28.9735 16.8904 29.3483C16.9926 29.7231 17.2036 30.0589 17.4967 30.3138C17.7898 30.5686 18.1518 30.7307 18.5371 30.7797C18.9223 30.8288 19.3135 30.7624 19.6611 30.5891C20.0086 30.4158 20.297 30.1434 20.4897 29.8063C20.6825 29.469 20.7708 29.0823 20.7438 28.6948C20.7069 28.1755 20.4654 27.6921 20.0725 27.3507C19.6796 27.009 19.1673 26.8373 18.6479 26.8731ZM19.8723 28.1324L18.8609 29.7269C18.849 29.7453 18.8334 29.7611 18.8153 29.7735C18.7971 29.786 18.7767 29.7945 18.7552 29.7989C18.7336 29.8033 18.7114 29.8033 18.6899 29.7991C18.6683 29.7947 18.6479 29.7861 18.6297 29.7739L17.7872 29.1919C17.7695 29.1796 17.7544 29.164 17.7427 29.1459C17.7311 29.1279 17.7231 29.1076 17.7192 29.0866C17.7115 29.0438 17.721 28.9998 17.7456 28.9641C17.7703 28.9283 17.8082 28.9038 17.8509 28.8961C17.8721 28.8923 17.8938 28.8926 17.9148 28.8972C17.9358 28.9017 17.9557 28.9103 17.9734 28.9226L18.6759 29.4082L19.5959 27.9577C19.6069 27.9385 19.6216 27.9216 19.6393 27.9083C19.6569 27.895 19.677 27.8854 19.6985 27.8799C19.72 27.8747 19.7423 27.8736 19.7641 27.8771C19.786 27.8806 19.8069 27.8887 19.8256 27.9004C19.8443 27.9123 19.8604 27.9278 19.8729 27.946C19.8855 27.9642 19.8942 27.9847 19.8985 28.0064C19.9029 28.0282 19.9028 28.0506 19.8983 28.0721C19.8938 28.0939 19.8849 28.1144 19.8723 28.1324Z"
                          fill="#6A35FF"
                          fillOpacity="0.01"
                        />
                      </g>
                      <path
                        d="M18.9213 30.5008C19.8341 30.437 20.5223 29.6453 20.4584 28.7325C20.3946 27.8196 19.6029 27.1315 18.6902 27.1954C17.7774 27.2592 17.0892 28.0509 17.153 28.9635C17.2169 29.8763 18.0085 30.5645 18.9213 30.5008Z"
                        fill="white"
                      />
                      <path
                        d="M18.6675 26.8731C18.28 26.9 17.9094 27.0414 17.6023 27.2792C17.2952 27.5169 17.0655 27.8405 16.9423 28.2088C16.8191 28.5771 16.8078 28.9735 16.91 29.3483C17.0121 29.7231 17.2231 30.0589 17.5162 30.3138C17.8093 30.5686 18.1714 30.7307 18.5566 30.7797C18.9419 30.8288 19.333 30.7624 19.6806 30.5891C20.0282 30.4158 20.3165 30.1434 20.5092 29.8063C20.7021 29.469 20.7904 29.0823 20.7634 28.6948C20.7265 28.1755 20.485 27.6921 20.092 27.3507C19.6992 27.009 19.1868 26.8373 18.6675 26.8731ZM19.8918 28.1324L18.8805 29.7269C18.8685 29.7453 18.853 29.7611 18.8348 29.7735C18.8167 29.786 18.7962 29.7945 18.7747 29.7989C18.7532 29.8033 18.731 29.8033 18.7094 29.7991C18.6879 29.7947 18.6674 29.7861 18.6492 29.7739L17.8067 29.1919C17.789 29.1796 17.7739 29.164 17.7623 29.1459C17.7506 29.1279 17.7426 29.1076 17.7388 29.0866C17.731 29.0438 17.7405 28.9998 17.7652 28.9641C17.7899 28.9283 17.8277 28.9038 17.8704 28.8961C17.8916 28.8923 17.9133 28.8926 17.9343 28.8972C17.9553 28.9017 17.9752 28.9103 17.9929 28.9226L18.6955 29.4082L19.6155 27.9577C19.6264 27.9385 19.6412 27.9216 19.6588 27.9083C19.6764 27.895 19.6966 27.8854 19.718 27.8799C19.7395 27.8747 19.7618 27.8736 19.7837 27.8771C19.8055 27.8806 19.8264 27.8887 19.8451 27.9004C19.8638 27.9123 19.8799 27.9278 19.8924 27.946C19.905 27.9642 19.9137 27.9847 19.9181 28.0064C19.9224 28.0282 19.9223 28.0506 19.9178 28.0721C19.9133 28.0939 19.9045 28.1144 19.8918 28.1324Z"
                        fill="#6A35FF"
                      />
                      <path
                        opacity="0.9"
                        d="M38.0372 26.5525L22.6016 27.6317C22.1189 27.6655 21.755 28.0841 21.7888 28.5668C21.8224 29.0493 22.2412 29.4132 22.7237 29.3795L38.1593 28.3001C38.642 28.2665 39.0059 27.8477 38.9721 27.3652C38.9385 26.8826 38.5197 26.5187 38.0372 26.5525Z"
                        fill="#D9DBE9"
                      />
                      <path
                        d="M19.5966 40.4335C20.5094 40.3697 21.1976 39.578 21.1337 38.6652C21.0699 37.7526 20.2782 37.0642 19.3655 37.1281C18.4527 37.1919 17.7645 37.9837 17.8283 38.8965C17.8921 39.8091 18.6838 40.4973 19.5966 40.4335Z"
                        fill="white"
                      />
                      <path
                        d="M19.3427 36.8058C18.9553 36.8328 18.5846 36.9742 18.2776 37.2119C17.9705 37.4497 17.7408 37.7733 17.6176 38.1415C17.4944 38.5098 17.4831 38.9063 17.5853 39.281C17.6874 39.6558 17.8984 39.9917 18.1915 40.2464C18.4846 40.5013 18.8467 40.6634 19.2319 40.7124C19.6172 40.7615 20.0083 40.6951 20.3559 40.5218C20.7034 40.3486 20.9918 40.0761 21.1845 39.7388C21.3772 39.4018 21.4657 39.0149 21.4386 38.6275C21.4016 38.1082 21.1602 37.6249 20.7674 37.2832C20.3745 36.9417 19.8621 36.77 19.3427 36.8058ZM20.5671 38.0651L19.5558 39.6597C19.5438 39.6781 19.5283 39.6938 19.5101 39.7063C19.492 39.7185 19.4715 39.7273 19.45 39.7317C19.4284 39.736 19.4063 39.736 19.3847 39.7317C19.3632 39.7275 19.3427 39.7189 19.3245 39.7066L18.482 39.1244C18.4643 39.1123 18.4492 39.0967 18.4375 39.0787C18.4259 39.0605 18.4179 39.0403 18.4141 39.0193C18.4063 38.9765 18.4158 38.9324 18.4405 38.8968C18.4652 38.8611 18.503 38.8366 18.5457 38.8288C18.5669 38.825 18.5886 38.8253 18.6096 38.8299C18.6306 38.8345 18.6505 38.843 18.6682 38.8553L19.3708 39.341L20.2908 37.8905C20.3017 37.8712 20.3165 37.8544 20.3341 37.8411C20.3517 37.8277 20.3719 37.8181 20.3933 37.8127C20.4148 37.8074 20.4371 37.8064 20.459 37.8099C20.4808 37.8134 20.5017 37.8213 20.5203 37.8332C20.5391 37.8449 20.5552 37.8605 20.5678 37.8787C20.5802 37.897 20.589 37.9174 20.5934 37.9392C20.5978 37.9609 20.5976 37.9831 20.593 38.0049C20.5887 38.0266 20.5797 38.0471 20.5671 38.0651Z"
                        fill="#D9DBE9"
                      />
                      <path
                        opacity="0.5"
                        d="M38.736 36.54L23.3003 37.6193C22.8176 37.6531 22.4537 38.0716 22.4875 38.5543C22.5212 39.037 22.9399 39.4009 23.4224 39.3671L38.8581 38.2877C39.3408 38.254 39.7046 37.8353 39.6708 37.3528C39.6372 36.8701 39.2185 36.5062 38.736 36.54Z"
                        fill="#D9DBE9"
                      />
                      <g filter="url(#filter4_d_2719_10761)">
                        <path
                          d="M56.9638 22.4355L39.58 21.2199C36.6843 21.0174 34.1726 23.2008 33.9701 26.0965L32.3289 49.5664C32.1264 52.4622 34.3098 54.9739 37.2055 55.1762L54.5893 56.3919C57.485 56.5943 59.9967 54.4109 60.1992 51.5152L61.8403 28.0453C62.0429 25.1495 59.8595 22.638 56.9638 22.4355Z"
                          fill="white"
                          fillOpacity="0.01"
                        />
                      </g>
                      <path
                        d="M56.9638 22.6391L39.58 21.4235C36.6843 21.221 34.1726 23.4044 33.9701 26.3001L32.3289 49.77C32.1264 52.6658 34.3098 55.1775 37.2055 55.3798L54.5893 56.5956C57.485 56.7979 59.9967 54.6147 60.1992 51.7188L61.8403 28.2489C62.0429 25.3532 59.8595 22.8416 56.9638 22.6391Z"
                        fill="white"
                      />
                      <path
                        d="M44.1567 29.1915L51.4564 29.7019"
                        stroke="#D9DBE9"
                        strokeWidth="0.700809"
                      />
                      <path
                        d="M52.6118 30.0228L52.1812 36.18"
                        stroke="#D9DBE9"
                        strokeWidth="0.628373"
                      />
                      <path
                        d="M47.3507 40.5776L47.0073 45.4886"
                        stroke="#D9DBE9"
                        strokeWidth="0.644092"
                      />
                      <g filter="url(#filter5_d_2719_10761)">
                        <path
                          d="M41.6101 32.5608C43.3668 32.6836 44.8904 31.3593 45.0132 29.6025C45.136 27.8459 43.8116 26.3224 42.0549 26.1995C40.2983 26.0767 38.7748 27.4011 38.6519 29.1577C38.5291 30.9144 39.8535 32.438 41.6101 32.5608Z"
                          fill="#3FCFFD"
                          fillOpacity="0.01"
                        />
                      </g>
                      <path
                        d="M41.6101 32.5461C43.3668 32.669 44.8904 31.3446 45.0132 29.588C45.136 27.8314 43.8116 26.3079 42.0549 26.1849C40.2983 26.0621 38.7748 27.3866 38.6519 29.1432C38.5291 30.8998 39.8535 32.4233 41.6101 32.5461Z"
                        fill="#3FCFFD"
                      />
                      <g filter="url(#filter6_d_2719_10761)">
                        <path
                          d="M55.9171 27.6655L50.088 27.258C49.5089 27.2173 49.0066 27.6541 48.966 28.2332L48.737 31.5089C48.6965 32.088 49.1331 32.5903 49.7123 32.6309L55.5413 33.0384C56.1205 33.0789 56.6228 32.6423 56.6633 32.0631L56.8925 28.7875C56.9329 28.2083 56.4962 27.706 55.9171 27.6655Z"
                          fill="#3F80FD"
                          fillOpacity="0.01"
                        />
                      </g>
                      <path
                        d="M55.9171 27.6699L50.088 27.2624C49.5089 27.2217 49.0066 27.6585 48.966 28.2376L48.737 31.5133C48.6965 32.0924 49.1331 32.5947 49.7123 32.6351L55.5413 33.0428C56.1205 33.0833 56.6228 32.6467 56.6633 32.0675L56.8925 28.7919C56.9329 28.2127 56.4962 27.7104 55.9171 27.6699Z"
                        fill="#3F80FD"
                      />
                      <g filter="url(#filter7_d_2719_10761)">
                        <path
                          d="M54.8774 35.0011L40.35 33.9852C39.4814 33.9244 38.7278 34.5795 38.667 35.4482L38.3731 39.6536C38.3123 40.5224 38.9673 41.2757 39.836 41.3365L54.3634 42.3524C55.2321 42.4132 55.9856 41.7581 56.0464 40.8894L56.3404 36.6841C56.4012 35.8152 55.7461 35.0619 54.8774 35.0011Z"
                          fill="#6A35FF"
                          fillOpacity="0.01"
                        />
                      </g>
                      <path
                        d="M54.8301 35.0011L40.3027 33.9852C39.434 33.9244 38.6805 34.5795 38.6197 35.4482L38.3257 39.6536C38.2649 40.5224 38.92 41.2757 39.7886 41.3365L54.316 42.3524C55.1847 42.4132 55.9382 41.7581 55.999 40.8894L56.293 36.6841C56.3538 35.8152 55.6987 35.0619 54.8301 35.0011Z"
                        fill="#6A35FF"
                      />
                      <g filter="url(#filter8_d_2719_10761)">
                        <path
                          d="M45.9348 44.9699C46.5193 44.1434 47.7718 44.231 48.2354 45.1307L50.2956 49.1278C50.7776 50.0626 50.0517 51.165 49.0024 51.0916L44.3457 50.7661C43.2964 50.6927 42.731 49.5001 43.3383 48.6412L45.9348 44.9699Z"
                          fill="#3F80FD"
                          fillOpacity="0.01"
                        />
                      </g>
                      <path
                        d="M45.967 44.929C46.5515 44.1026 47.804 44.1902 48.2676 45.0898L50.3278 49.0869C50.8098 50.0218 50.0839 51.1241 49.0346 51.0507L44.3779 50.7252C43.3286 50.6518 42.7633 49.4592 43.3705 48.6003L45.967 44.929Z"
                        fill="#3F80FD"
                      />
                      <defs>
                        <filter
                          id="filter0_d_2719_10761"
                          x="0.211378"
                          y="0.47115"
                          width="55.38"
                          height="58.2499"
                          filterUnits="userSpaceOnUse"
                          colorInterpolationFilters="sRGB"
                        >
                          <feFlood
                            floodOpacity="0"
                            result="BackgroundImageFix"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="1.40162" />
                          <feGaussianBlur stdDeviation="5.60647" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_2719_10761"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_2719_10761"
                            result="shape"
                          />
                        </filter>
                        <filter
                          id="filter1_d_2719_10761"
                          x="12.9852"
                          y="14.4484"
                          width="10.2108"
                          height="10.2107"
                          filterUnits="userSpaceOnUse"
                          colorInterpolationFilters="sRGB"
                        >
                          <feFlood
                            floodOpacity="0"
                            result="BackgroundImageFix"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="0.654536" />
                          <feGaussianBlur stdDeviation="1.57089" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0.415686 0 0 0 0 0.207843 0 0 0 0 1 0 0 0 0.26 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_2719_10761"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_2719_10761"
                            result="shape"
                          />
                        </filter>
                        <filter
                          id="filter2_d_2719_10761"
                          x="13.3323"
                          y="19.4149"
                          width="10.2108"
                          height="10.2106"
                          filterUnits="userSpaceOnUse"
                          colorInterpolationFilters="sRGB"
                        >
                          <feFlood
                            floodOpacity="0"
                            result="BackgroundImageFix"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="0.654536" />
                          <feGaussianBlur stdDeviation="1.57089" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0.415686 0 0 0 0 0.207843 0 0 0 0 1 0 0 0 0.26 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_2719_10761"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_2719_10761"
                            result="shape"
                          />
                        </filter>
                        <filter
                          id="filter3_d_2719_10761"
                          x="13.6795"
                          y="24.3812"
                          width="10.2108"
                          height="10.2106"
                          filterUnits="userSpaceOnUse"
                          colorInterpolationFilters="sRGB"
                        >
                          <feFlood
                            floodOpacity="0"
                            result="BackgroundImageFix"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="0.654536" />
                          <feGaussianBlur stdDeviation="1.57089" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0.415686 0 0 0 0 0.207843 0 0 0 0 1 0 0 0 0.26 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_2719_10761"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_2719_10761"
                            result="shape"
                          />
                        </filter>
                        <filter
                          id="filter4_d_2719_10761"
                          x="21.103"
                          y="11.3956"
                          width="51.9635"
                          height="57.6239"
                          filterUnits="userSpaceOnUse"
                          colorInterpolationFilters="sRGB"
                        >
                          <feFlood
                            floodOpacity="0"
                            result="BackgroundImageFix"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="1.40162" />
                          <feGaussianBlur stdDeviation="5.60647" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0.0684399 0 0 0 0 0.0653299 0 0 0 0 0.220833 0 0 0 0.33 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_2719_10761"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_2719_10761"
                            result="shape"
                          />
                        </filter>
                        <filter
                          id="filter5_d_2719_10761"
                          x="36.7168"
                          y="25.3156"
                          width="10.2314"
                          height="10.2315"
                          filterUnits="userSpaceOnUse"
                          colorInterpolationFilters="sRGB"
                        >
                          <feFlood
                            floodOpacity="0"
                            result="BackgroundImageFix"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="1.05121" />
                          <feGaussianBlur stdDeviation="0.963612" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0.247059 0 0 0 0 0.811765 0 0 0 0 0.992157 0 0 0 0.29 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_2719_10761"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_2719_10761"
                            result="shape"
                          />
                        </filter>
                        <filter
                          id="filter6_d_2719_10761"
                          x="46.6319"
                          y="25.8538"
                          width="12.3655"
                          height="9.9905"
                          filterUnits="userSpaceOnUse"
                          colorInterpolationFilters="sRGB"
                        >
                          <feFlood
                            floodOpacity="0"
                            result="BackgroundImageFix"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="0.700809" />
                          <feGaussianBlur stdDeviation="1.05121" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0.247059 0 0 0 0 0.501961 0 0 0 0 0.992157 0 0 0 0.25 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_2719_10761"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_2719_10761"
                            result="shape"
                          />
                        </filter>
                        <filter
                          id="filter7_d_2719_10761"
                          x="36.6171"
                          y="33.8061"
                          width="21.4791"
                          height="11.879"
                          filterUnits="userSpaceOnUse"
                          colorInterpolationFilters="sRGB"
                        >
                          <feFlood
                            floodOpacity="0"
                            result="BackgroundImageFix"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="1.57682" />
                          <feGaussianBlur stdDeviation="0.876011" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0.414166 0 0 0 0 0.208333 0 0 0 0 1 0 0 0 0.12 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_2719_10761"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_2719_10761"
                            result="shape"
                          />
                        </filter>
                        <filter
                          id="filter8_d_2719_10761"
                          x="40.636"
                          y="42.8228"
                          width="12.2645"
                          height="11.6011"
                          filterUnits="userSpaceOnUse"
                          colorInterpolationFilters="sRGB"
                        >
                          <feFlood
                            floodOpacity="0"
                            result="BackgroundImageFix"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="0.876011" />
                          <feGaussianBlur stdDeviation="1.22642" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0.247059 0 0 0 0 0.501961 0 0 0 0 0.992157 0 0 0 0.26 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_2719_10761"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_2719_10761"
                            result="shape"
                          />
                        </filter>
                      </defs>
                    </svg>
                  </span>
                  <h4 className="mt-3 mb-3">Flexible Subscription</h4>
                  <p className="mb-4">
                    Be available right where your custom collaboration messages
                    in one place Build better bonds automatically.
                  </p>
                  <Link
                    href="/register"
                    className="read-more-link dat-about-btn"
                  >
                    Free sign up{" "}
                    <i className="fa-solid fa-arrow-right-long ms-1"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <img
          src="assets/img/shape/arrow-multiple.png"
          alt="arrow"
          className="arrow-multiple position-absolute z--1"
        />
      </section>
    </>
  );
};

export default AgencyHowItWork;
